import React, { memo } from 'react';
import { Card, LoadingButton, Stack, Typography } from 'investira.react.components';
import AvaliacoesGestorEditStatusView from './AvaliacoesGestorEditStatusView';

const AvaliacoesGestorEditGateView = memo(props => {
  const { disabled, mode, onAceitar, onRecusar } = props;

  if (mode === 'entregue') {
    return (
      <AvaliacoesGestorEditStatusView
        title="Obrigado pelo envio."
        description="Sua avaliação foi entregue com sucesso."
        helperText="O formulário foi encerrado e não pode mais ser alterado."
      />
    );
  }

  if (mode === 'encerrada') {
    return (
      <AvaliacoesGestorEditStatusView
        title="Questionário Concluído com Sucesso"
        description="Agradecemos por sua contribuição para nossa avaliação."
        // helperText="Esta avaliação foi encerrada e não pode mais ser acessada."
      />
    );
  }

  return (
    <Card sx={{ p: 4 }}>
      <Stack data-testid="avaliacao-gestor-gate" gap={3} alignItems="center">
        <Stack gap={1} alignItems="center" sx={{ maxWidth: 420 }}>
          <Typography variant="h5" color="textPrimary" sx={{ textAlign: 'center' }}>
            Deseja prosseguir com o questionário?
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center' }}>
            Antes de iniciar, confirme se deseja aceitar o preenchimento desta avaliação.
          </Typography>
        </Stack>

        <Stack direction="row" gap={1} justifyContent="center" flexWrap="wrap">
          <LoadingButton
            data-testid="avaliacao-gestor-gate-reject"
            variant="text"
            type="button"
            onClick={onRecusar}
            disabled={disabled}>
            Recusar avaliação
          </LoadingButton>
          <LoadingButton
            data-testid="avaliacao-gestor-gate-accept"
            variant="contained"
            type="button"
            onClick={onAceitar}
            disabled={disabled}>
            Aceitar e prosseguir
          </LoadingButton>
        </Stack>
      </Stack>
    </Card>
  );
});

export default AvaliacoesGestorEditGateView;
